<mat-card class="order-summary-card">
  <div class="order-summary-card-header"><div class="dots"></div></div>
  <mat-card-content class="empty-order-content"
                    fxLayout="column"
                    fxLayoutAlign="center center"
                    fxLayoutGap="8px">



    <img fxHide fxShow.gt-md [src]="'assets/images/ticket/ticket.png'">

    <span class="no-ticket-text">{{"shared.labels.noTicket"|translate}}</span>

    <p fxHide fxShow.gt-md class="no-ticket-desc">{{"shared.labels.selectTicketRightAway"|translate}}</p>

    <button mat-stroked-button
            translate="shared.labels.findTicket"
            (click)="findTicket()"></button>
  </mat-card-content>
</mat-card>
